'use strict';

var constants = require('../constants/constants');

module.exports = constants(['PENDING', 'FAILED', 'DONE', 'FETCH_FAILED']);


//////////////////
// WEBPACK FOOTER
// ./node_modules/marty-lib/modules/store/fetchConstants.js
// module id = XQqe
// module chunks = 88